import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import withIsFocused from '../../../decorators/withIsFocused';
import { setGuideStatus } from '../../../redux/actions/tutorialGuideActions';
import { setViewedHome } from '../../../redux/actions/updateMemberInfoActions';
import { makeMemberInfoByKey } from '../../../redux/selectors/member';
import PopupGroup from './PopupGroup';

const mapStateToProps = () => {
  const selector = createStructuredSelector({
    isViewedHome: makeMemberInfoByKey('isViewedHome'),
  });

  return state => selector(state);
};

const mapDispatchToProps = {
  setGuideStatus,
  setViewedHome,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withIsFocused(PopupGroup));
